let _globals: Record<string, any>;

export const setupGlobals = (globalProperties: Record<string, any>): void => {
  _globals = Object.seal({ ...globalProperties });
};

export const useGlobals = () => {
  return _globals;
};
